import { createContext } from "react";
import { UserInfo } from "../types/UserInfo";

export interface UserContextType {
  userInfo: UserInfo;
}

export const UserContext = createContext({} as UserContextType);

export type UserProviderProps = {
  userInfo: UserInfo;
  children: React.ReactNode;
};

const UserProvider: React.FC<UserProviderProps> = ({ userInfo, children }) => {
  return (
    <UserContext.Provider value={{ userInfo }}>{children}</UserContext.Provider>
  );
};

export default UserProvider;
